import store, { useAppSelector } from '../redux/store';
import { updatePage } from '../redux/commonSlice';

import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { ProductionListApiData } from '../types';

interface Props {
  listData?: ProductionListApiData | any[];
  setPageChange: (page: number) => void;
  limit?: number;
  totalRecords?: number;
  pageNo?: number;
}

export default function TablePagination({
  listData,
  setPageChange,
  limit = 10,
  totalRecords,
  pageNo,
}: Props) {
  const total = totalRecords || listData?.setCount;
  const { page } = useAppSelector(state => state.common);

  const { dispatch } = store;

  // console.log(total)

  // Calculate total pages based on the total records and the limit
  const totalPages = total ? Math.ceil(total / limit || 8) : 0;

  return (
    <Pagination
      shape="rounded"
      color="primary"
      variant="outlined"
      className="reelPagination"
      boundaryCount={1} // Show 1 page at the start and end (e.g., 1 ... 10)
      siblingCount={1}
      // siblingCount={0}
      page={pageNo ? pageNo : page}
      renderItem={item => (
        <PaginationItem
          slots={{
            previous: ArrowBackIcon,
            next: ArrowForwardIcon,
          }}
          {...item}
        />
      )}
      onChange={(e, val: number) => {
        setPageChange(val);
        if (!pageNo) {
          dispatch(updatePage(val));
        }
      }}
      count={totalPages}
    />
  );
}
